export const getIntervalError = (contract, errors, periods) => {
    const interval = contract.interval;
    if (interval == undefined) {
        return errors;
    }
    const valid = periods
        .map((period) => period?.recurring?.period)
        .filter((periodValue) => typeof periodValue === "number" && Number.isFinite(periodValue))
        .sort((value1, value2) => value1 - value2);
    if (valid.length && !valid.includes(interval)) {
        errors.interval = [
            ...(errors.interval ?? []),
            `Ugyldig intervall, endre til et gyldig intervall: ${valid.join(", ")}.`,
        ];
    }
    return errors;
};
